<template lang='pug'>
.industry-appliction-container
    .base-title {{ title }}
    .item-wrapper
        .item(
            v-for='(item, k) in options',
            :key="item.id"
            v-src='item.detail.banner',
            @click='itemClick(item)'
        )
            .row {{ item.name }}
</template>

<script>
import SectionPanel from './components/Panel/SectionPanel'
import dataDic from '@/assets/data/dic'

import anime from 'animejs'
import { getDataHierarchy, getDataRows, getPathNames } from '@custouch/proxy-use'
export default {
    // props: ['title'],
    data() {
        return {
            options: [],
            title: ''
        }
    },
    methods: {
        itemClick(item) {
            if(item.detail.levelLink){
                window.location.href = item.detail.levelLink
                this.$message.loading({
                    message: '跳转中...',
                    forbidClick: true,
                    duration: 3000
                })
                return
            }
            if(item.detail.isList){
                this.$router.push({
                    name: 'industryList',
                    params: {
                        hId: item.id
                    }
                })
            }else if(item.data.length){
                this.$router.push({
                    name: 'productDetail',
                    params: {
                        rId: item.data[0].id
                    },
                    query: {
                        hId: item.id
                    }
                })
            }
            // if(item.children[0].levelLink){
            //     window.location.href = item.children[0].levelLink
            //     return
            // }
            // if (item.children[0].isList) {
            //     this.$router.push({ name: 'industryList', params: { level1 } })
            // } else {
            //     this.$router.push({ name: 'productDetail', params: { section: this.title, name: item.children[0].name } })
            // }
        }
    },
    components: {
        SectionPanel
    },
    async created() {
        const { DATA } = window.env
        const { module, template } = DATA
        const [ret, title,{data}] = await Promise.all([
            getDataHierarchy({dataHierarchyId: module.productTech.hierarchies.Application}),
            getPathNames(module.productTech.hierarchies.Application),
            getDataRows({
                dataHierarchyId: module.productTech.hierarchies.Application,
                dataTemplateId: template.productTech,
                index: 1,
                size: 99,
                recursive: true,
                includeParentDataHierarchyIds: true
            })
        ])
        this.title = ret.name
        this.options = ret.dataHierarchies.map(item=>{
            let list = data.filter(d=>d.dataHierarchyIds.includes(item.id))
            if(list && list.length){
                return Object.assign(item, {data: list})
            }
            return item
        })
        this.$root.$emit('pageview',{
            title
        })
        // const data = await this.$store.dispatch('getJson', dataDic[this.title])
        // this.options = data.reduce((pre, cur) => {
        //     if (pre[cur.level1]) {
        //         pre[cur.level1].children.push(cur)
        //     } else {
        //         pre[cur.level1] = {
        //             children: [cur],
        //             img: cur.banner
        //         }
        //     }
        //     return pre
        // }, {})
        this.$nextTick(() => {
            anime({
                targets: '.item',
                opacity: [0, 1],
                translateX: (el, i) => {
                    if (i % 2 === 0) {
                        return ['-100%', 0]
                    } else {
                        return ['100%', 0]
                    }
                },
                delay: anime.stagger(150, { easing: 'easeInQuad' }),
                easing: 'spring(1, 80, 10, 0)'
            })
        })
    }
}
</script>

<style scoped lang='less'>
.industry-appliction-container {
    padding: 0 0.8rem 10vh;
}
.item-wrapper {
    display: flex;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;
    .item {
        opacity: 0;
        width: 7.9rem;
        height: 6rem;
        background: transparent no-repeat center/cover;
        display: flex;
        align-items: flex-end;
        &:not(:last-child) {
            margin-bottom: 1.2rem;
        }
        .row {
            background: linear-gradient(135deg, #7abac9 92%, #fff 92%);
            text-align: center;
            color: #fff;
            font-size: 0.7rem;
            width: 100%;
            line-height: 1rem;
            position: relative;
            &::after {
                content: '';
                background: url('~@/assets/imgs/arrow.png') no-repeat
                    center/contain;
                width: 0.3rem;
                height: 0.3rem;
                position: absolute;
                right: 0.1rem;
                bottom: 0.1rem;
            }
        }
    }
}
</style>